import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import SocketIO from 'socket.io-client'

import { Quasar, quasarUserOptions } from './quasar-user-options'

import 'shared-ritm/style'

const app = createApp(App)

//@ts-ignore
window.io = SocketIO

const pinia = createPinia()

//@ts-ignore
app.use(Quasar, quasarUserOptions)
app.use(pinia)
app.use(router)

//@ts-ignore
window.getMainAppAuthStore = () => {
  const { useAuthStore } = require('@/pinia/auth/useAuthStore')
  return useAuthStore()
}

app.mount('#app')
